import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTrending1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconTrending1"><Path d="M2.5 13.0625L4.61111 9.875L7.77778 15.1875L13.0556 3.5L18.3333 20.5L21.5 14.125" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconTrending1;
